
import Topbar from './Topbar';
import Navbar from './Navbar';
import Hero from './Hero';
import Start from './Start';
import Section from './Section';
import Schedule from './Schedule';
import Apply from './Apply';
import Footer from './Footer';
import Sticky from './Sticky';

export default function App() {
  return (
    <>
      <Topbar />
      <Navbar />
      <Hero />
      <Start />
      <Section />
      <Schedule />
      <Apply />
      <Footer />
      <Sticky />
    </>
  );
}